"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var GradientProgressBar_1 = __importDefault(require("atomicComponents/molecules/ProgressBar/GradientProgressBar"));
var OnboardingSteps_1 = __importDefault(require("containers/Onboarding/OnboardingSteps"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var selectors_1 = require("./selectors");
var OnboardingLayout = function () {
    var _a = (0, react_redux_1.useSelector)(selectors_1.selectOnboardingProgress), totalSteps = _a.totalSteps, stepsDone = _a.stepsDone;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ md: 6, item: true, pl: 2 }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Onboarding Steps" })) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ md: 6, justifyContent: "flex-end", item: true, pr: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 0.5 }, { children: (0, jsx_runtime_1.jsx)(GradientProgressBar_1.default, { value: (stepsDone / totalSteps) * 100 }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: 1, mt: 1, display: "inline-flex", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2, component: "span" }, { children: [stepsDone, " of ", totalSteps, " done"] })) }))] })), (0, jsx_runtime_1.jsx)(OnboardingSteps_1.default, {})] }));
};
exports.default = OnboardingLayout;
